module.exports = __webpack_public_path__ + "static/media/pic8.ff6ce9b6.jpg";